import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD1DmqyPjz6uEPls6JeO2fMp7slSesNxdE",
  authDomain: "haacke-tokyo.firebaseapp.com",
  databaseURL: "https://haacke-tokyo-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "haacke-tokyo",
  storageBucket: "haacke-tokyo.firebasestorage.app",
  messagingSenderId: "402046950401",
  appId: "1:402046950401:web:1510e7d952dc2552a37400"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const database = getDatabase(app);
export const auth = getAuth(app);

export default app;
